import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const STATUSES = ["new", "reviewing", "interview", "hired", "rejected"];

export default function Applications() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/driver_applications").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (it, status) => {
    try { await api.put(`/admin/driver_applications/${it.id}`, { ...it, status }); toast.success("Updated"); load(); } catch { toast.error("Failed"); }
  };
  const remove = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/driver_applications/${id}`); load(); };

  return (
    <div>
      <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-2">// Driver Applications</div>
      <h1 className="font-display font-black text-4xl text-white uppercase mb-8">CDL Applications</h1>
      <div className="space-y-4">
        {items.length === 0 && <div className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6 text-slate-500 text-sm">No applications yet.</div>}
        {items.map((it) => (
          <div key={it.id} className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6" data-testid={`app-${it.id}`}>
            <div className="flex flex-col md:flex-row md:justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-head uppercase tracking-widest text-white">{it.full_name}</span>
                  <span className="text-xs font-mono-lt text-[var(--lt-accent-bright)]">CDL {it.cdl_class}</span>
                  <span className="text-xs text-slate-500">{it.years_experience} yrs</span>
                </div>
                <div className="text-xs text-slate-500 mt-1">{it.email} · {it.phone}{it.phone_secondary ? ` / ${it.phone_secondary}` : ""} · {it.city_state}</div>
                {it.endorsements && <div className="text-xs text-slate-400 mt-1">Endorsements: {it.endorsements}</div>}
                {it.available_start_date && <div className="text-xs text-slate-400 mt-1">Available: {it.available_start_date}</div>}
                {it.resume_url && <a href={it.resume_url} target="_blank" rel="noreferrer" className="text-xs text-[var(--lt-accent-bright)] mt-1 inline-block">Resume ↗</a>}
                {it.driving_experience && <div className="mt-2 text-sm text-slate-300">{it.driving_experience}</div>}
                {it.message && <div className="mt-2 text-sm text-slate-400 border-l-2 border-[var(--lt-accent)] pl-3">{it.message}</div>}
              </div>
              <div className="flex items-center gap-2">
                <Select value={it.status} onValueChange={(v) => setStatus(it, v)}>
                  <SelectTrigger className="w-32 bg-[var(--lt-bg)] border-[var(--lt-border)] text-white h-9 rounded-xl text-xs uppercase"><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
                <Button size="sm" variant="ghost" onClick={() => remove(it.id)} className="text-slate-500 hover:text-red-400 rounded-xl">Delete</Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
